import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const tokensApi = createApi({
  reducerPath: 'getTokens',
  baseQuery: fetchBaseQuery({ baseUrl: 'https:/' }),
  endpoints: builder => ({
    getPancakeswapTokens: builder.query<Array<any>, void>({
      query: () => 'tokens.pancakeswap.finance/pancakeswap-extended.json',
      transformResponse: (response: any) => {
        return response.tokens
      }
    }),
    getUniswapTokens: builder.query<Array<any>, void>({
      query: () => 'tokens.coingecko.com/uniswap/all.json',
      transformResponse: (response: any) => {
        return response.tokens
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPancakeswapTokensQuery, useGetUniswapTokensQuery } = tokensApi
